// Slot for the notification bell in AdminLayout header.
// Imports the real NotificationBell component.
import { NotificationBell } from "@/components/admin/notifications/NotificationBell";

export default function NotificationBellSlot() {
  return <NotificationBell />;
}
